// extracted by mini-css-extract-plugin
export default {"videoPlayer":"Video_videoPlayer__JATGo","iframe":"Video_iframe__LvbZK"};